import type { BudgetRange } from '@/types/contact';
import { z } from 'zod';

const PHONE_REGEX = /^(?:\+44|0)[1-9]\d{8,9}$/;

const BUDGET_VALUES = [
  'Gold Package | £1,595 or £79 Per Month',
  'Platinum Package | £1,995 or £89 Per Month',
  'Diamond Package | £2,595 or £99 Per Month'
] as const satisfies readonly BudgetRange[];

export const contactFormSchema = z.object({
  wedding_date: z.string()
    .min(1, 'Wedding date is required')
    .regex(/^\d{2}-\d{2}-\d{4}$/, 'Date must be in DD-MM-YYYY format'),
  
  budget: z.enum(BUDGET_VALUES, {
    errorMap: () => ({ message: 'Please select a package' })
  }),
  
  first_name: z.string()
    .min(1, 'First name is required')
    .max(100, 'First name is too long'),
  
  partner_name: z.string()
    .min(1, "Partner's name is required")
    .max(100, "Partner's name is too long"),
  
  email: z.string()
    .min(1, 'Email is required')
    .email('Invalid email address'),
  
  mobile: z.string()
    .min(1, 'Mobile number is required')
    .regex(PHONE_REGEX, 'Invalid UK mobile number'),
  
  ceremony_location: z.string()
    .min(1, 'Ceremony location is required')
    .max(200, 'Ceremony location is too long'),
  
  wedding_county: z.string()
    .min(1, 'Wedding county is required')
    .max(100, 'Wedding county is too long'),
  
  message: z.string()
    .max(1000, 'Message is too long')
    .optional()
    .transform(val => val || ''), // Convert undefined to empty string
}); 